import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("TokenResponse")
export class TokenResponse {

  access_token: string;

  expires_in: number;

  token_type: string;

  scope: string;

  forceNewPassword: boolean;

  usuario: string;

}
